import type { QuickWin } from "../lib/types";

interface Props {
  wins: QuickWin[];
}

function effortBadge(effort: QuickWin["effort"]) {
  const map = {
    low: "bg-green-100 text-green-700",
    medium: "bg-amber-100 text-amber-700",
    high: "bg-red-100 text-red-700",
  } as const;
  return (
    <span
      className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-medium ${map[effort]}`}
    >
      {effort.charAt(0).toUpperCase() + effort.slice(1)} effort
    </span>
  );
}

export default function QuickWins({ wins }: Props) {
  if (wins.length === 0) {
    return (
      <div className="rounded-xl border border-ink-200 bg-white p-6 text-ink-500 text-sm">
        No quick wins surfaced. Strong AEO foundation.
      </div>
    );
  }
  return (
    <ul className="space-y-3">
      {wins.map((w, idx) => (
        <li
          key={idx}
          className="rounded-xl border border-ink-200 bg-white p-5"
        >
          <div className="flex items-start justify-between gap-4">
            <h4 className="text-ink-900 font-medium">{w.item}</h4>
            {effortBadge(w.effort)}
          </div>
          <p className="text-ink-500 mt-2 text-sm">{w.impact}</p>
        </li>
      ))}
    </ul>
  );
}
